import React, { Component } from 'react';
import PropTypes from 'prop-types';
import clone from 'ramda/src/clone';
import isNil from 'ramda/src/isNil';
import includes from 'ramda/src/includes';
import moment from 'moment';
import CheckBox from '@components/@core/CheckBox';
import CheckIcon from '@components/@core/CheckIcon';
import EditDropdown from '@components/EditDropdown';
import Thumbnail from '@components/@core/Thumbnail';
import { UserRoles, AdminDotsType, UserDotsType } from '~/services/config';

class LearnFeedList extends Component {
    state = {
        status: '',
        dueDate: null,
    };

    static getDerivedStateFromProps(nextProps, prevState) {
        const { course } = nextProps;
        const { due_at, data } = course;
        const dueDate = moment(due_at).format('MMM D');
        let status = '';
        const now = moment();
        const result = moment(due_at).isBefore(now);
        if (result) {
            status = 'Past due, ';
        } else {
            status = '';
        }
        if (data.child_count === 0 || data.completed === 0) {
            status = status + 'Not Started';
        } else if (data.child_count === data.completed) {
            status = status + 'Completed';
        } else {
            status = status + 'In Progress';
        }

        return { status, dueDate };
    }

    render() {
        const { bulk, selected, user, userRole, course, onClick, onSelect, onBulkSelect, dataCy } = this.props;
        const { data, program_id, assigned_by } = course;
        const { child_count, completed, thumb_url } = data;
        const { dueDate, status } = this.state;
        const dotsMenu = userRole > UserRoles.MANAGER ? clone(UserDotsType) : AdminDotsType;
        if (userRole > UserRoles.MANAGER && assigned_by === user && !includes('Delete', dotsMenu)) {
            dotsMenu.push('Delete');
        }

        return (
            <div className={`learn-feed-list-container ${selected ? 'bulked' : ''}`} data-cy={dataCy}>
                <div className="learn-feed-list">
                    <div className="list-contents">
                        <div className="feed-container d-flex ssm-column">
                            <div className="d-flex ssm-column d-flex-5 pe-4 ssp-r-0 cursor-pointer" onClick={() => onClick()}>
                                <div className="d-h-between d-flex-1 me-2 ssm-r-0 mb-0 ssm-b-3">
                                    <div className="d-flex d-flex-1 ai-center">
                                        <div className="mr-2 ssm-r-0">
                                            <CheckIcon size={26} checked={child_count === completed} />
                                        </div>
                                        <Thumbnail source={thumb_url} size="tiny" />
                                    </div>
                                    <div className="d-md-none feed-dot-menu">
                                        <EditDropdown options={dotsMenu} disabled={bulk} onChange={onSelect} dataCy="threeDotMenu" />
                                    </div>
                                </div>
                                <div className="d-flex-3">
                                    <p data-cy="learnFeedTitle" className={`dsl-b14 mb-1 text-400 ${child_count === completed ? ' text-line-through' : ''}`}>
                                        {data.name}
                                    </p>
                                    <p className="dsl-m12 mb-0 text-400">
                                        Assigned:
                                        {isNil(program_id) ? (assigned_by === user ? ' Self Assigned' : ' Health Coach Assigned') : ` Health Plan Assigned`}
                                    </p>
                                </div>
                            </div>
                            <div className="d-h-center align-items-baseline d-flex-5 d-flex ssm-column mt-2">
                                <div className="tablet-flex d-flex-2 text-end dsl-b12 text-400 mx-md-2">
                                    <label className="dsl-b14 me-2 tablet-block text-start w-sm-80">Module</label>
                                    <div>{child_count || 0}</div>
                                </div>
                                <div className="tablet-flex d-flex-2 text-end dsl-b12 text-400 mx-md-2">
                                    <label className="dsl-b14 me-2 tablet-block text-start w-sm-80">Complete</label>
                                    <div>{completed}</div>
                                </div>
                                <div className="tablet-flex d-flex-2 text-end dsl-b12 text-400 mx-md-2">
                                    <label className="dsl-b14 me-2 tablet-block text-start w-sm-80">Due</label>
                                    <div>{dueDate}</div>
                                </div>
                                <div className="d-flex-1 text-400 d-none" />
                                <div className="tablet-flex d-flex-4 text-start dsl-b12 text-400 mx-md-2">
                                    <label className="dsl-b14 me-2 tablet-block text-start w-sm-80">Status</label>
                                    <div>{status}</div>
                                </div>
                                {!bulk && (
                                    <div className="d-flex-1 jc-end desktop-only">
                                        <EditDropdown options={dotsMenu} disabled={bulk} onChange={onSelect} dataCy="threeDotMenu" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {bulk && (
                    <div className="bulk-unassign">
                        {isNil(program_id) && <CheckBox size="tiny" id={course.id} checked={selected} reversed={bulk && selected} onChange={(e) => onBulkSelect(course, e.target.checked)} />}
                    </div>
                )}
            </div>
        );
    }
}

LearnFeedList.propTypes = {
    bulk: PropTypes.bool,
    user: PropTypes.number,
    userRole: PropTypes.number,
    course: PropTypes.any,
    onClick: PropTypes.func,
    onSelect: PropTypes.func,
    onBulkSelect: PropTypes.func,
};

LearnFeedList.defaultProps = {
    bulk: false,
    user: 0,
    userRole: 1,
    course: {},
    onClick: () => {},
    onSelect: () => {},
    onBulkSelect: () => {},
};

export default LearnFeedList;
